// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"88019840","76":"1aa1ddac","229":"78de216e","354":"ea03da8c","397":"7dd0e137","596":"3563a5f0","701":"41e59a92","784":"7ec70fe3","785":"410d0d78","863":"78a66924"}[chunkId] + ".chunk.js";
};